






















































































import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {LadingStatus} from "@/enums/status";
import {EmployeeType, FreightServiceType, LadingType, PartnerType} from "@/enums/type";
import {getValuesEnum} from "@/shared/services/helper/utils";
import {LadingStore} from "@/modules/ladings/store";
import debounce from "lodash/debounce";
import {LadingParams} from "@/modules/ladings/params";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import {difference} from 'lodash';
import PostOfficeForm from "@/modules/postoffices/Form/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import moment from "moment";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import {allLading} from "@/modules/ladings/services";

@Component({
    name: "LadingSearch",
    components: {
        CustomerSelector,
        PartnerSelector,
        EmployeeSelector,
        PostOfficeSelector,
        PostOfficeForm, FreightServiceSelector, MillisecondDatePicker, ProvinceSelector, EnumSelector
    }
})
export default class extends mixins(CommonMixin) {
    LadingStatus = LadingStatus;
    LadingType = LadingType;
    FreightServiceType = FreightServiceType;
    EmployeeType = EmployeeType;
    PartnerType = PartnerType;
    form = new LadingParams();
    customerFilter = {
        customerRowGuid: undefined
    };
    isExporting = false;
    json_fields = {
        "Ngày, giờ gửi": {
            field: "dateOfAcceptance",
            callback: (val) => {
                return val ? moment(val).format(FORMAT_DATE_TIME_PICKER) : ''
            }
        },
        "Mã vận đơn": "ladingCode",
        "Vận đơn ĐT": "partnerLadingCode",
        "Bưu cục nhận": "acceptancePostOffice.name",
        "Bưu cục phát": "deliveryPostOffice.name",
        "Tuyến phát": {
            callback: (value) => {
                if (value.deliveryEmployee) {
                    return value.deliveryEmployee?.fullname;
                } else {
                    return value.deliveryPartner?.name;
                }
            }
        },
        "Đại diện gửi": "locationFrom.name",
        "Mã khách hàng": "customer.customerCode",
        "Tỉnh đến": "locationTo.province.name",
        "Địa chỉ": {
            field: "locationTo",
            callback: (value) => {
                return `${value.address}, ${value.ward?.name}, ${value.district?.name}, ${value.province?.name}`
            }
        },
        "Dịch vụ": "freightService.serviceCode",
        "Thu hộ": "codMoney",
        "Tổng cước": "totalFee",
        "Thu tiền NN": "receiverCollect",
        "Trạng thái": {
            field: "status",
            callback: (value) => {
                return this.$t(`LadingStatus.${LadingStatus[value]}`);
            }
        },
        "Loại đơn": {
            field: "type",
            callback: (value) => {
                return this.$t(`LadingType.${LadingType[value]}`);
            }
        }
    }

    created() {
        this.form.statusString = difference(getValuesEnum(LadingStatus), this.LADING_STATUS_BEFORE_STOCKIN).join(",");
    }

    // @Watch('form', {immediate: false, deep: true})
    onValuesChange() {
        if (!this.form?.status && this.form.statusString) {
          this.form.statusString = difference(getValuesEnum(LadingStatus), [...this.LADING_STATUS_BEFORE_STOCKIN, LadingStatus.Reject]).join(",");
        }
        LadingStore.updateLadingParams(this.form);
        LadingStore.listLading({...LadingStore.params, page: 1})
        // this.handleChange(val);
    }

    // handleChange = debounce(function (val) {
    //     LadingStore.updateLadingParams(val);
    //     LadingStore.listLading({...LadingStore.params, page: 1})
    // }, 500);

    changeCustomerCode(value) {
        this.form = { ...this.form, customerCode: value?.customerCode };
    }

    get nameFileExcel() {
        return "Danh sách vận đơn";
    }

    async getDataExport() {
        try {
            this.isExporting = true;
            const { data } = await allLading({
                ...LadingStore.params
            });
            return data.datas;
        } catch (e) {
        } finally {
            this.isExporting = false;
        }
    }
}
